import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { FinishRepository } from '@efficiently/client-api-project-locations';

import { FinishGqlRepository } from './repositories/finish-gql.repository';

export function provideLocationsDataAccess(): EnvironmentProviders {
	return makeEnvironmentProviders([{ provide: FinishRepository, useClass: FinishGqlRepository }]);
}
